import React from 'react';
import PropTypes from 'prop-types';
import { generateStars } from 'utils/formatting';
import { formatTimestamp } from 'utils/dateUtils';
import GoogleLogo from 'components/svg/GoogleLogo';
import './GoogleReviewCard.scss';

const GoogleReviewCard = ({
	reviewerName,
	reviewerPhoto,
	rating,
	reviewDate,
	reviewText,
}) => (
	<div className="google-review-card">
		<div className="google-review-card__header">
			<img
				className="google-review-card__avatar"
				src={reviewerPhoto || ''}
				alt={`${reviewerName}'s profile`}
				referrerPolicy="no-referrer"
				onError={(e) => {
					e.currentTarget.style.visibility = 'hidden';
				}}
			/>
			<span className="google-review-card__name">{reviewerName}</span>
			<GoogleLogo />
		</div>

		<div className="google-review-card__meta">
			<div className="google-review-card__stars">
				{generateStars(rating, 16, 16, '#FFCC00')}
			</div>
			{reviewDate && (
				<span className="google-review-card__date">
					{formatTimestamp(reviewDate, 'review')}
				</span>
			)}
		</div>

		<p className="google-review-card__text">{reviewText}</p>
	</div>
);

GoogleReviewCard.propTypes = {
	reviewerName: PropTypes.string.isRequired,
	reviewerPhoto: PropTypes.string,
	rating: PropTypes.number.isRequired,
	reviewDate: PropTypes.number,
	reviewText: PropTypes.string,
};

export default GoogleReviewCard;
